import { render, staticRenderFns } from "./DuplicateDossiersModal.vue?vue&type=template&id=eb604ef8&"
import script from "./DuplicateDossiersModal.vue?vue&type=script&lang=js&"
export * from "./DuplicateDossiersModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports